<template>
  <div class="main">
    <report-top>
      <template slot="title"> 表单管理 </template>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div id="text">表单模板列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small" icon="md-add"
          >新增</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增表单模板' : '编辑表单模板'"
      width="700"
      ref="formModel"
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [],
      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        name: "",
        moduleTable: "",
        flowId: "",
        flowName: "",
        serverUrl: "",
        field: "456",
        rule: "",
        content: "",
      },
      ruleValidate: {},

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      forms: [
        {
          title: "名称",
          key: "name",
          key1: "name",
          type: "Input",
          required: true,
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
        },
        {
          title: "流程名称",
          key: "flowId",
          key1: "flowName",
          type: "selectFlow",
          required: false,
        },
        {
          title: "接口地址",
          key: "serverUrl",
          key1: "serverUrl",
          type: "Input",
          required: true,
        },
        {
          title: "模板id",
          key: "field",
          key1: "field",
          type: "Input",
          required: true,
        },
        {
          title: "显示规则",
          key: "rule",
          key1: "rule",
          type: "Input",
          required: false,
        },
        {
          title: "内容",
          key: "content",
          key1: "content",
          type: "Input",
          required: false,
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/form/list",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        this.tableData = data;
      });
    },

    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.flow + "/form/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        axios({
          method: "post",
          url: this.axios.flow + "/form/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: this.axios.flow + "/form/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    cols() {
      this.columns = [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ];
      var b = JSON.parse(JSON.stringify(this.forms));
      b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        b[i].key = b[i].key1;
      }
      this.columns.splice(1, 0, ...b);

      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
  },
  mounted() {
    this.getList();
    this.cols();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/diaodu/form.vue